var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.6863 2.68629 0 6 0H25C28.3137 0 31 2.68629 31 6V14.1121C31 17.403 28.3506 20.0751 25.0684 20.1118C24.0312 21.9609 22.207 23.3802 20 24.0001V20.1121H6C2.68629 20.1121 0 17.4258 0 14.1121V6ZM25 5H6V7H25V5ZM6 9H25V11H6V9ZM25 13H6V15H25V13Z",
    fill: "#FF892A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25C32.3137 25 35 22.3137 35 19C35 15.6863 32.3137 13 29 13C25.6863 13 23 15.6863 23 19C23 22.3137 25.6863 25 29 25Z",
    fill: "#52ACBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5645 16.1498C27.174 15.7593 26.5408 15.7593 26.1503 16.1498C25.7598 16.5404 25.7598 17.1735 26.1503 17.564L27.5861 18.9998L26.1503 20.4355C25.7598 20.8261 25.7598 21.4592 26.1503 21.8498C26.5408 22.2403 27.174 22.2403 27.5645 21.8498L29.0003 20.414L30.436 21.8498C30.8266 22.2403 31.4597 22.2403 31.8502 21.8498C32.2408 21.4592 32.2408 20.8261 31.8502 20.4355L30.4145 18.9998L31.8502 17.564C32.2408 17.1735 32.2408 16.5404 31.8502 16.1498C31.4597 15.7593 30.8266 15.7593 30.436 16.1498L29.0003 17.5856L27.5645 16.1498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentFailed);
export default __webpack_public_path__ + "static/media/comment-failed.ee3556336e210edea1e7dd81f17389dc.svg";
export { ForwardRef as ReactComponent };